export default function PageHeader({
  title,
  eyebrow,
  summary,
  meta,
  actions,
  className = "",
}) {
  return (
    <header className={`ds-page-header${className ? ` ${className}` : ""}`}>
      <div className="ds-page-header__main">
        <div className="ds-page-header__copy">
          {eyebrow ? <span className="ds-page-header__eyebrow">{eyebrow}</span> : null}
          <h1 className="ds-page-header__title">{title}</h1>
        </div>
        {summary ? <div className="ds-page-header__summary">{summary}</div> : null}
      </div>
      {meta || actions ? (
        <div className="ds-page-header__side">
          {meta ? <div className="ds-page-header__meta">{meta}</div> : null}
          {actions ? <div className="ds-page-header__actions">{actions}</div> : null}
        </div>
      ) : null}
    </header>
  );
}
